(ns splash.ui.lender-portal.common.formatters
  "Functions to normalize programatic values (Timestamps, numbers, etc) into values safe for display"
  (:import
    (goog.i18n
      NumberFormat
      currency)))

(defn number->currency
  "Format a numeric `value` like `20.105` into its local currency format `\"$20.11\"`
   NOTE: This will round decimal values with more than 2 places"
  [value]
  (let [fmt (NumberFormat. (.getLocalCurrencyPattern currency "USD"))]
    (.format fmt value)))
